import { environment } from './../../../environments/environment';
import { Pipe, PipeTransform } from '@angular/core';

const URL_BACKEND = environment.urlBackend;

@Pipe({
  name: 'mediaPlanes'
})
export class MediaPlanesPipe implements PipeTransform {

  /**
   * Debe recibir el type: ejemplo 'pdf' y el valor ejemplo nombre_pdf.pdf
   * @param type
   * @param value
   * @returns
   */
  transform( type: string, value: string ): string {
    return `${ URL_BACKEND }/media/getUrlMediaPlanes/${type}/${value}`;
  }

}
